export const environment = {
  production: false,
  srecApiUrl: 'https://apim-sprucepowermarketingdesk-tst.azure-api.net',
  srecApiKey: 'fa43332e8dbb4b428d1df998f60f5b0d'
};